export default __webpack_public_path__ + "static/N0176-958238c870a76afaf8196e519393ecb4.png";